import { connect } from 'react-redux';
import { Map } from 'immutable';

import decorate from '../../../../utils/decorate';

import { request } from '../../../../modules/customers/actions/update';

import {MarketingTab} from "./MarketingTab";

function mapStateToProps(state, props) {
    const id = parseInt(props.id, 10);

    let update = state.customers.get('update').get(id) || Map();

    return {
        status: update.get('state'),
        errors: update.get('errors'),
        customer: state.customers.get('list').get(id) || Map()
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onUpdateRequest: (id, data) => dispatch(request(id, data))
    };
}

export default decorate(
    connect(mapStateToProps, mapDispatchToProps),
    MarketingTab
);
